import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auth/profile.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var updateUserInfo = (_0) => __async(void 0, [_0], function* ({ user, locale = "en" }) {
  var _a, _b, _c, _d, _e;
  try {
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: `/update-profile?lang=${lang}`,
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify({
          first_name: user.first_name,
          last_name: user.last_name,
          city: user.city,
          country: user.country,
          nationality: user.nationality,
          dob: user.dob,
          gender: user.gender,
          email: user.email,
          cell_country_code: user.cell_country_code,
          cell_number: user.cell_number,
          favorite_team: user.favorite_team,
          passport_data: user.passport_data,
          lang,
          skip_phone_validation: true,
          country_code: user.cell_country_code,
          phone: user.cell_number
        })
      }
    });
    if (((_c = data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      throw (data == null ? void 0 : data.error) || { message: (_d = data.original) == null ? void 0 : _d.error, phone: (_e = data.original) == null ? void 0 : _e.error };
    }
    return data.data.user;
  } catch (error) {
    throw new Exception({
      error,
      name: "updateUserInfoException",
      context: error
    });
  }
});

export {
  updateUserInfo
};
//# sourceMappingURL=chunk-LUGUSHUV.mjs.map